import React from 'react';
import { Form, Input } from 'antd';

const PlaceAutocomplete = ({ form, fieldName, label, callback}) => {

  // No script tag here on purpose. PrivateLayout loads the Google Maps API once
  // app-wide (with libraries=places), and both users of this component are
  // Topbar modals inside that layout. Loading it again — as this used to, twice
  // over on the SAR modal since it renders two of these — triggers Google's
  // "included the Google Maps JavaScript API multiple times" error.

  const handlePlaceSelect = (fieldName) => {
    return () => {
      if (!window.google?.maps?.places) return;

      const autocomplete = new window.google.maps.places.Autocomplete(
        document.getElementById(`autocomplete-${fieldName}`)
      );

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if(callback){
          callback({
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          })
        }
        form.setFieldsValue({ [fieldName]: place.formatted_address });
      });
    };
  };

  return (
    <Form.Item label={label} name={fieldName}>
      <Input
        id={`autocomplete-${fieldName}`}
        placeholder={`Enter your ${label}`}
        onChange={handlePlaceSelect(fieldName)}
        size="large"
      />
    </Form.Item>
  );
};

export default PlaceAutocomplete;